<template>
  <div class="menu-item">
    <router-link
      class="menu-link"
      exact-active-class="active"
      :to="menuItem.route"
    >
      <span class="menu-icon">
        <span class="svg-icon">
          <inline-svg class="inline-svg" :src="menuItem.svgIcon" />
        </span>
      </span>
      <span class="menu-title">{{ menuItem.heading }}</span>
      <span class="menu-arrow"></span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  props: {
    menuItem: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.menu-item {
  color: #334f7c;
}

.menu-title {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 12px;
}
.inline-svg {
  width: 20px;
}
</style>
